import React from 'react';
import classNames from 'classnames/bind';
import { Footer } from "./Footer";
import { ActionBar } from "./Footer/components";
import { InfoTags } from "./components/InfoTags";
import { ActionCard, AsadeImage, Container, Description, Price, PriceError, Title } from "./components";
import styles from "./styles.pcss";
import { isDateInPast, shouldRenderPrice } from "./utils";
var cn = classNames.bind(styles);
export var SubscriptionCard = function SubscriptionCard(_ref) {
  var values = _ref.values,
    alias = _ref.alias,
    className = _ref.className,
    description = _ref.description,
    errorPriceMessage = _ref.errorPriceMessage,
    expiryDate = _ref.expiryDate,
    fee = _ref.fee,
    feePeriod = _ref.feePeriod,
    feeTooltip = _ref.feeTooltip,
    imageDesktop = _ref.imageDesktop,
    imageMobile = _ref.imageMobile,
    image = _ref.image,
    isPromo = _ref.isPromo,
    link = _ref.link,
    nextFee = _ref.nextFee,
    onClick = _ref.onClick,
    promoExpiryDate = _ref.promoExpiryDate,
    title = _ref.title,
    withPriceBlock = _ref.withPriceBlock,
    buttonText = _ref.buttonText,
    detailsUrl = _ref.detailsUrl;
  var isPromoExpired = isDateInPast(promoExpiryDate);
  var renderPrice = shouldRenderPrice(fee, nextFee);
  return /*#__PURE__*/React.createElement(Container, {
    className: cn('container', className),
    key: title,
    "data-t-id": "components-SubscriptionCard"
  }, /*#__PURE__*/React.createElement(ActionCard, {
    link: link,
    onClick: onClick,
    title: title,
    "data-t-id": "components-SubscriptionCard"
  }), /*#__PURE__*/React.createElement(Container, {
    className: cn('aside')
  }, /*#__PURE__*/React.createElement(AsadeImage, {
    imageDesktop: imageDesktop || image,
    imageMobile: imageMobile,
    "data-t-id": "components-SubscriptionCard"
  })), /*#__PURE__*/React.createElement(Container, {
    className: cn('body')
  }, /*#__PURE__*/React.createElement(Title, {
    title: title,
    "data-t-id": "components-SubscriptionCard"
  }), /*#__PURE__*/React.createElement(InfoTags, {
    values: values
  }), /*#__PURE__*/React.createElement(Container, {
    className: cn('content')
  }, /*#__PURE__*/React.createElement(Description, {
    description: description,
    "data-t-id": "components-SubscriptionCard"
  })), /*#__PURE__*/React.createElement(Footer, {
    actionBar: /*#__PURE__*/React.createElement(ActionBar, {
      href: detailsUrl,
      text: buttonText,
      title: title,
      type: "link",
      visible: true
    }),
    className: cn('footer'),
    price: /*#__PURE__*/React.createElement(Price, {
      alias: alias,
      expiryDate: expiryDate,
      fee: fee,
      feePeriod: feePeriod,
      feeTooltip: feeTooltip,
      isPromo: isPromo,
      isPromoExpired: isPromoExpired,
      nextFee: nextFee,
      promoExpiryDate: promoExpiryDate
    }),
    priceError: /*#__PURE__*/React.createElement(PriceError, {
      errorPriceMessage: errorPriceMessage
    }),
    renderPrice: renderPrice,
    withPriceBlock: withPriceBlock
  })));
};